window.FichaCrediarioController = ControllerBase.extend({
    name: "FichaCrediarioController",
    framework: 'knockout',

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'CPF/CNPJ', prop: 'CpfCnpj' },
            { title: 'Nome', prop: 'Nome' }
        ],
        getData: function () {
            var cliente = this.cliente
                ? this.cliente
                : ControllerBase.instances['CadastroClienteController']
                    ? ControllerBase.instances['CadastroClienteController'].model
                    : null;
            return this.toJS(cliente);
        },
    }),

    ajax: function () {

        return {
            url: "/Cliente/_FichaCrediario",
            type: "post",
            cache: false,
            data: {
                codigoCliente: this.codigoCliente
            }
        };
    },

    obterValor: function (model) {

        switch (model.Tipo()) {
            case 1014:
                return model.Valor() ? global.formatNumber(model.Valor()) : null;
            case 1015:
                return model.Data() ? global.formatDateTime(model.Data()) : null;
            case 1016:
                return model.TextoLongo();
            default:
                return model.Texto();
        }
    }

});